<script>
	import Header from "../Header.svelte";
	import Welcome from "./Welcome.svelte";
	import Preview from "./Preview.svelte";
	import Features from "./Features.svelte";
	import Download from "./Download.svelte";

	import { reportHomeVisit } from "../statsclient";

	let visitReported = false;

	window.addEventListener("scroll", () => {
		if (visitReported) return;

		visitReported = true;
		reportHomeVisit();
	});
</script>

<style>
	.container {
		display: flex;
		flex-flow: column nowrap;
	}

	@media (min-width: 640px) {
		.container {
			max-width: none;
		}
	}
</style>

<div class="container">
	<Header />
	<Welcome />
	<Preview />
	<Features />
	<Download />
</div>